module.exports = __webpack_public_path__ + "f930cdf1528e46dc5bd57acdbd4c51a5.svg";